import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router';

import { ContactUsIcon, OrderIssueIcon } from 'honeydew/icons/Account';
import CancelOrderIcon from 'honeydew/icons/Orders/CancelOrderIcon';
import useBrandLinks from 'hooks/useBrandLinks';
import { trackEvent } from 'utils/analyticsUtils';

import CancelOrderModal from '../CancelOrderModal';

const buttonLinkClasses = 'flex items-center gap-10 rounded-full bg-white px-15 py-10 font-grotesk-bold';

function NeedHelpBanner({ boxNumber, chargeID, displayCancelOrder, displayReportIssue, orderID }) {
    const location = useLocation();
    const { customerCare, faqs, helpCenter } = useBrandLinks();

    const [cancelOrderModal, setCancelOrderModal] = useState(false);

    const startCancellationFlow = () => {
        setCancelOrderModal(true);
        trackEvent('late cancel start click', { pathname: location.pathname });
    };

    const handleLinkClick = (e, href) => {
        if (window.isNativeApp) {
            e.preventDefault();
            window.ReactNativeWebView?.postMessage(
                JSON.stringify({
                    navigate: 'OrderLink',
                    url: href,
                })
            );
        }
    };

    return (
        <div className="mt-20 rounded-md bg-off-white px-20 py-15">
            <p className="mb-15 font-grotesk-bold">Need Help?</p>
            <div className="mx-auto flex w-full flex-wrap items-center gap-10 text-center">
                {displayReportIssue && (
                    <Link className={buttonLinkClasses} to={`/account/orders/details/${orderID}/${boxNumber}/report`}>
                        <OrderIssueIcon />
                        Report Issue
                    </Link>
                )}

                {displayCancelOrder && (
                    <button type="button" className={buttonLinkClasses} onClick={startCancellationFlow}>
                        <CancelOrderIcon />
                        Cancel Order
                    </button>
                )}

                <a
                    className={buttonLinkClasses}
                    href={customerCare}
                    onClick={(e) => handleLinkClick(e, customerCare)}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <ContactUsIcon />
                    Contact Us
                </a>

                <a
                    className="link mx-10"
                    href={faqs}
                    onClick={(e) => handleLinkClick(e, faqs)}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    FAQs
                </a>

                <a
                    className="link mx-10"
                    href={helpCenter}
                    onClick={(e) => handleLinkClick(e, helpCenter)}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Help Center
                </a>
            </div>

            {displayCancelOrder && (
                <CancelOrderModal
                    cancelOrderModal={cancelOrderModal}
                    setCancelOrderModal={setCancelOrderModal}
                    chargeID={chargeID}
                />
            )}
        </div>
    );
}

NeedHelpBanner.propTypes = {
    boxNumber: PropTypes.number.isRequired,
    chargeID: PropTypes.number.isRequired,
    displayCancelOrder: PropTypes.bool,
    displayReportIssue: PropTypes.bool,
    orderID: PropTypes.number.isRequired,
};

NeedHelpBanner.defaultProps = {
    displayCancelOrder: true,
    displayReportIssue: true,
};

export default NeedHelpBanner;
